import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBannerTextOnImage = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 48.956 36.717",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Tekst_p\\xE5_bilde",
		"data-name": "Tekst p\\xE5 bilde",
		transform: "translate(-1259 -1159.998)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Union_11",
				"data-name": "Union 11",
				d: "M8693.077,22820.715a4.093,4.093,0,0,1-4.077-4.076v-28.562a4.093,4.093,0,0,1,4.077-4.078h40.8a4.1,4.1,0,0,1,4.083,4.078v28.563a4.094,4.094,0,0,1-4.083,4.076Z",
				transform: "translate(-7430 -21624)"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape",
				d: "M0,2.04V0H14.278V2.04Z",
				transform: "translate(1280.417 1185.496) rotate(180)",
				fill: "#fff",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape-2",
				"data-name": "Shape",
				d: "M0,2.04V0H14.278V2.04Z",
				transform: "translate(1280.417 1179.377) rotate(180)",
				fill: "#fff",
				fillRule: "evenodd"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape-3",
				"data-name": "Shape",
				d: "M0,2.04V0H14.278V2.04Z",
				transform: "translate(1280.417 1173.258) rotate(180)",
				fill: "#fff",
				fillRule: "evenodd"
			})
		]
	})
});
export default SvgBannerTextOnImage;
